export enum OrganizationUserStatusEnum {
  ACTIVE = 1,
  INVITED = 2,
  VERIFIED = 3,
  BLOCKED = 4,
  REMOVED = 5,
}
